export const KEEP_OPEN = 'KEEP_OPEN';
export var ActionKind;
(function (ActionKind) {
    ActionKind["open"] = "open";
    ActionKind["close"] = "close";
    ActionKind["filter"] = "filter";
    ActionKind["up"] = "ArrowUp";
    ActionKind["down"] = "ArrowDown";
    ActionKind["left"] = "ArrowLeft";
    ActionKind["right"] = "ArrowRight";
    ActionKind["enter"] = "enter";
})(ActionKind || (ActionKind = {}));
//# sourceMappingURL=types.js.map